import PropTypes from "prop-types";
import { useState, useEffect } from "react";
import { Col, Row } from "react-bootstrap";
import { useDispatch } from "react-redux";

import {
  NoDataMessage,
  SectorAllocationContainer,
} from "features/Strategy/v2/Detail/StrategyDetails.styles";

import { toast } from "Layout/slice";
import { Button } from "components/Button";
import { parseErrorMessage, roundOff } from "utils";
import { Title } from "style/components/Title.styles";
import { getIndustry } from "features/Strategy/service";
import { getFilteredSectorAllocation } from "features/Strategy/utils";
import SectorAllocationPlaceholder from "./Placeholders/SectorAllocationPlaceholder";

const SectorAllocation = ({ data, isLoading, isPublicStrategy }) => {
  const dispatch = useDispatch();

  const [industryData, setIndustryData] = useState();
  const [isActive, setIsActive] = useState("strategy");
  const [sectorAllocation, setSectorAllocation] = useState([]);

  useEffect(() => {
    if (!isPublicStrategy) {
      getIndustryColors();
    }
  }, [isPublicStrategy]);

  useEffect(() => {
    if (data.industries || data.industries_benchmark) {
      const _industries =
        isActive == "strategy" ? data.industries : data?.industries_benchmark;

      if (_industries) {
        setSectorAllocation(getFilteredSectorAllocation(_industries));
      } else {
        setSectorAllocation([]);
      }
    }
  }, [isActive, data.industries, data.industries_benchmark]);

  const getIndustryColors = async () => {
    try {
      const response = await getIndustry();
      setIndustryData(response);
    } catch (error) {
      console.error(error);
      dispatch(
        toast({
          type: "error",
          body: parseErrorMessage(error),
        })
      );
    }
  };

  const getColor = (label) => {
    const industryDetails = industryData?.find(
      (industry) => industry.label === label
    );

    return industryDetails?.value || "";
  };

  if (isLoading) {
    return <SectorAllocationPlaceholder />;
  }

  return (
    <SectorAllocationContainer>
      <span className="header">
        <Title>Sector allocation</Title>
        <Button
          size={"small"}
          disabled={isPublicStrategy}
          variant={isActive === "strategy" ? "primary" : "secondary"}
          onClick={() => setIsActive("strategy")}
        >
          Strategy
        </Button>
        <Button
          width={120}
          size={"small"}
          disabled={isPublicStrategy}
          variant={isActive === "sp500" ? "primary" : "secondary"}
          onClick={() => setIsActive("sp500")}
          className="text-nowrap"
        >
          S&P 500
        </Button>
      </span>
      <div className="divider my-3"></div>

      {sectorAllocation.length ? (
        <>
          <div className="line-wrapper">
            {sectorAllocation.map(({ label, value }) => (
              <div
                key={label}
                className="line"
                style={{
                  backgroundColor: getColor(label),
                  width: `${roundOff(value * 100, 0)}%`,
                }}
              />
            ))}
            {/* <div className="line bg-2" />
                <div className="line bg-3" />
                <div className="line bg-4" />
                <div className="line bg-5" />
                <div className="line bg-6" />
                <div className="line bg-7" />
                <div className="line bg-8" />
                <div className="line bg-9" />
                <div className="line bg-10" /> 
            */}
          </div>

          {sectorAllocation.map(({ label, value }, inx) => (
            <Row className="list-wrapper" key={inx}>
              <Col md={9} lg={10} xs={9} className="label">
                <div className="dot-wrapper">
                  <div
                    className="dot"
                    style={{ backgroundColor: getColor(label) }}
                  />
                </div>
                <span className="dot-label">{label}</span>
              </Col>
              <Col md={3} lg={2} xs={3} className="value">
                {roundOff(value * 100, 0)}%
              </Col>
            </Row>
          ))}
        </>
      ) : (
        <NoDataMessage>No data to display</NoDataMessage>
      )}
    </SectorAllocationContainer>
  );
};

SectorAllocation.propTypes = {
  data: PropTypes.object,
  isLoading: PropTypes.bool,
  isPublicStrategy: PropTypes.bool,
};

export default SectorAllocation;
